import {NeoSelect} from "@/components/forms";
import {SelectItem} from "@nextui-org/react";
import {FaLayerGroup} from "react-icons/fa";

type groupingFilter = {
  label: string;
  id: number;
  url: string;
};
type GroupingFilterProps = {
  groupingFilter: groupingFilter[];
  onChangeGroupingElement: any;
  selectedGroupingFilter?: groupingFilter | null;
};
const GroupingFilter = ({
  groupingFilter,
  onChangeGroupingElement,
  selectedGroupingFilter
}: GroupingFilterProps) => {
  const handleGroupChange = (val: string) => {
    const groupData = groupingFilter.find((ele: any) => ele.id == val);
    onChangeGroupingElement(groupData);
  };
  return (
    <>
      <div className="flex w-[150px] flex-col">
        {groupingFilter && (
          <NeoSelect
            label=""
            size="md"
            className="w-full"
            placeholder="Group by"
            selectedKeys={
              selectedGroupingFilter ? [String(selectedGroupingFilter.id)] : []
            }
            onSelectionChange={keys => {
              const first = Array.isArray(keys)
                ? keys[0]
                : Array.from(keys as Set<unknown>)[0];
              const value: any =
                first !== undefined && first !== null ? String(first) : null;
              handleGroupChange?.(value);
            }}
            startContent={<FaLayerGroup className="h-4 w-4 text-[#1e2a44]" />}
          >
            {groupingFilter.map((item: any) => (
              <SelectItem key={item.id} value={item.id}>
                {item.label}
              </SelectItem>
            ))}
          </NeoSelect>
        )}
      </div>
    </>
  );
};

export default GroupingFilter;
